import $ from "jquery";
import ky from "ky";
import Toastify from "toastify-js";

document.addEventListener("alpine:init", () => {
    window.Alpine.data("cartPopup", () => ({
        open: false,
        isShowingCart: true,
        init() {
            this.updateCartPopup();
            $(document).on("wc_fragment_refresh", () => {
                this.updateCartPopup();
            });

            $(this.$refs.cart).on("change", "input.qty", (event) => {
                this.updateItemQuantity(event);
            });
            $(this.$refs.cart).on("click", ".cart-item-remove", (event) => {
                this.removeItem(event);
            });
            $(document).on("submit", "body.single-product form.cart:not(.in_loop)", (event) => {
                this.addItem(event);
            });

            $("body").on("added_to_cart", (event, fragmentsJSON, fragmentsHash, button) => {
                if (typeof fragmentsJSON === "undefined") {
                    fragmentsJSON = JSON.parse(
                        JSON.stringify(sessionStorage.getItem(wc_cart_fragments_params.fragment_name)),
                    );
                }

                if (
                    fragmentsJSON?.cart_popup_already_added_once === true &&
                    alpineData?.notice_type_on_already_added_product === "toast"
                ) {
                    const message = `Product is toegevoegd aan je <a href="${alpineData.cart_url}">winkelwagen</a>`;
                    this.createToast(message, "success");
                    this.updateCartPopupHtml(fragmentsJSON.cart_popup_cart, fragmentsJSON.cart_popup_count);
                } else if (typeof fragmentsJSON.cart_popup_product !== "undefined") {
                    this.updateCartPopupHtml(fragmentsJSON.cart_popup_product, fragmentsJSON.cart_popup_count);
                    this.open = true;
                    this.isShowingCart = false;
                }
            });
        },
        toggleCart(open) {
            this.open = open;

            if (!open && !this.isShowingCart) {
                this.isShowingCart = true;
                $(document.body).trigger("wc_fragment_refresh");
            }
        },
        async updateCartPopup() {
            const formData = new FormData();
            formData.append("action", "wpsoup/woocommerce/cart_popup/update_cart");

            this.blockElements();

            try {
                const response = await ky
                    .post(frameworkGlobal.ajaxurl, {
                        body: formData,
                    })
                    .json();
                this.updateCartPopupHtml(response.cart_content, response.count);
            } catch (error) {
                console.error(error);
            } finally {
                this.unblockElements();
            }
        },
        updateCartPopupHtml(cart_content = "", count = "") {
            let popup = this.$refs.cart;
            if (!popup) {
                return;
            }

            popup = $(popup);
            if (cart_content) {
                const content = popup.find(".offcanvas-inner");
                content.html(cart_content);
            }
            if (count !== "") {
                const shoppingCartButtonCount = $(".shopping-cart-button .count");
                shoppingCartButtonCount.html(count);
            }

            $(document).trigger("wpsoup/woocommerce/cart_popup/after_update", [popup, content, footer]);
        },
        async updateItemQuantity(event) {
            event.preventDefault();

            const quantity = $(event.currentTarget);
            const formData = new FormData();
            formData.append("action", "wpsoup/woocommerce/cart_popup/update_cart_item");
            formData.append("item_key", quantity.attr("name").replace(/\[|\]|cart|qty/gi, ""));
            formData.append("qty", quantity.val());

            try {
                await ky
                    .post(frameworkGlobal.ajaxurl, {
                        body: formData,
                    })
                    .json();
                $(document.body).trigger("wc_fragment_refresh");
            } catch (error) {
                console.error(error);
            }
        },
        async removeItem(event) {
            event.preventDefault();

            const removeButton = $(event.currentTarget);
            const itemKey =
                removeButton.data("item_key") ?? this.getUrlParameter(removeButton.attr("href"), "remove_item");
            const formData = new FormData();
            formData.append("action", "wpsoup/woocommerce/cart_popup/remove_cart_item");
            formData.append("item_key", itemKey);

            try {
                await ky
                    .post(frameworkGlobal.ajaxurl, {
                        body: formData,
                    })
                    .json();
                $(document.body).trigger("wc_fragment_refresh");
            } catch (error) {
                console.error(error);
            }
        },
        async addItem(event) {
            const form = $(event.currentTarget);
            const button = form.find('button[type="submit"]');
            const productId = form.find('[name="add-to-cart"]').val();
            if (form.parents(".product-type-external").length === 1) {
                return;
            }

            event.preventDefault();

            const formData = new FormData();
            $.each(form.find("input[type='file']"), function (i, tag) {
                $.each($(tag)[0].files, function (i, file) {
                    formData.append(tag.name, file);
                });
            });
            $.each(form.serializeArray(), function (i, val) {
                formData.append(val.name, val.value);
            });
            formData.append("action", "wpsoup/woocommerce/cart_popup/add_cart_item");
            !formData.getAll("add-to-cart").length && productId && formData.append("add-to-cart", productId);
            !formData.getAll("product_id").length && productId && formData.append("product_id", productId);

            $(document).trigger("wpsoup/woocommerce/cart_popup/item/adding");

            button.prop("disabled", true).addClass("loading").removeClass("added");

            try {
                const response = await ky
                    .post(window.location.href, {
                        body: formData,
                    })
                    .json();
                if (typeof response.error !== "undefined") {
                    form.parents("div.product").before(response.error);
                    $("body, html").animate(
                        {
                            scrollTop: 0,
                        },
                        500,
                    );
                } else {
                    $(document.body).trigger("added_to_cart", [response.fragments, response.cart_hash, button]);
                }
            } catch (error) {
                console.error(error);
            } finally {
                button.prop("disabled", false).removeClass("loading").addClass("added");
            }

            $(document).trigger("wpsoup/woocommerce/cart_popup/item/added");
        },
        blockElements() {
            let popup = this.$refs.cart;
            if (!popup) {
                return;
            }

            const loadingIcon = '<iconify-icon class="iconify icon-spin icon-2x" icon="fas:spinner"></iconify-icon>';
            popup = $(popup);
            popup.find(".offcanvas-inner").blockElement({
                html: loadingIcon,
            });
        },
        unblockElements() {
            let popup = this.$refs.cart;
            if (!popup) {
                return;
            }

            popup = $(popup);
            popup.find(".offcanvas-inner").unblockElement();
        },
        getUrlParameter(sURL, sParam) {
            const urlParams = new URL(sURL);

            return urlParams.searchParams.get(sParam);
        },
        createToast(message, type = "success") {
            let noticeType = "success";
            let noticeIcon = "fas:check-circle";
            if (type === "error") {
                noticeType = "error";
                noticeIcon = "fas:times-circle";
            } else if (type === "info") {
                noticeType = "info";
                noticeIcon = "fas:info-circle";
            }

            const html = `<div class="toast-inner"><iconify-icon class="iconify" icon="${noticeIcon}"></iconify-icon>${message}</div>`;
            requestAnimationFrame(() => {
                const toast = Toastify({
                    text: html,
                    escapeMarkup: false,
                    duration: 10000,
                    className: noticeType,
                    gravity: Foundation.MediaQuery.atLeast("sm") ? "top" : "bottom", // `top` or `bottom`
                    position: Foundation.MediaQuery.atLeast("sm") ? "right" : "center", // `left`, `center` or `right`
                    stopOnFocus: true, // Prevents dismissing of toast on hover
                    onClick: function () {
                        toast.hideToast();
                    }, // Callback after click
                }).showToast();
            });
        },
    }));
});
